import { Clock } from "@/components/ui/CurrentTime.tsx"
import img_light from "@/assets/images/login_background_light.png"
import img_dark from "@/assets/images/login_background_dark.png"
// import {Card} from "@/components/ui/Card.tsx";
import { Flex } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { Navigate, Outlet } from "react-router"
import { LocalStorage } from "@/helpers/LocalStorage.ts"
import { useAppSelector } from "@/store/store.ts"

// const loginImageStyle = {
//   backgroundSize: "cover",
//   backgroundPosition: "center",
//   backgroundRepeat: "no-repeat",
//   width: "100%",
//   height: "100%",
// }

export function LoginLayout() {
  const theme = useAppSelector((state) => state.uiPreferences.theme)
  const token = LocalStorage.getSecret("token")
  if (token !== null) {
    return <Navigate to="/dashboard" />
  }
  return (
    <Flex
      wrap
      alignItems="center"
      justifyContent="space-evenly"
      width="100vw"
      height="100vh"
      gap="size-250"
      UNSAFE_className="animate-in fade-in zoom-in"
      UNSAFE_style={{
        background: `url(${theme === "light" ? img_light : img_dark})`,
      }}
    >
      <Clock />
      <Outlet />
    </Flex>
  )
}
